import { CSS3DRenderer } from "three/addons/renderers/CSS3DRenderer.js";
//#region ../src/visualization/css3d-renderer-manager.ts
/**
* Create and configure a CSS3DRenderer overlay for the given container.
*
* The CSS3D layer is positioned absolutely over the container with
* `pointer-events: none` so it does not intercept clicks intended
* for the WebGL canvas underneath.
*
* **Requirement:** The `container` element must have `position: relative`,
* `absolute`, `fixed`, or `sticky`. If the container is `position: static`
* (the CSS default), the overlay will float to the nearest positioned
* ancestor instead of aligning with the container.
*/
function createCss3dRendererManager(container, width, height) {
	const cssRenderer = new CSS3DRenderer();
	cssRenderer.setSize(width, height);
	const el = cssRenderer.domElement;
	el.style.position = "absolute";
	el.style.top = "0px";
	el.style.left = "0px";
	el.style.pointerEvents = "none";
	container.appendChild(el);
	let disposed = false;
	return {
		render(scene, camera) {
			if (disposed) return;
			cssRenderer.render(scene, camera);
		},
		setSize(w, h) {
			cssRenderer.setSize(w, h);
		},
		dispose() {
			if (disposed) return;
			disposed = true;
			if (el.parentElement) el.parentElement.removeChild(el);
		}
	};
}
//#endregion
export { createCss3dRendererManager };
